import { useRef, useState } from 'react'
import GIcon from "../GIcon"
import WavesurferPlayer from '@wavesurfer/react'
import WaveSurfer from 'wavesurfer.js'

export function AudioMsg({ url }: {url: string }) {
   const [wavesurfer, setWavesurfer] = useState<WaveSurfer|null>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const onReady = (ws) => {
    setWavesurfer(ws)
    setIsPlaying(false)
  }

    const onPlayPause = () => {
        wavesurfer?.playPause()
    }

  return (
    <div className='flex flex-row items-center w-56 audio-wraper'>
            <WavesurferPlayer
                height={50}
                barHeight={30}
                barGap={2}
                waveColor="black"
                url={url}
                onReady={onReady}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                
            />
            <GIcon className='cursor-pointer' name={`${isPlaying ? 'pause' : 'play_circle'}`} onClick={onPlayPause} />
        </div>
    )
}
